function getFocusableElements(container) {
  // Query selector pattern for focusable elements
  const selector = "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe";

  // Use container as the root element to find focusable elements
  const elements = container.querySelectorAll(selector);
  // Convert NodeList to an array and return
  return Array.from(elements);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];


  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {

    !elements.includes(event.target) && first.focus();
     
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;
    
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  setTimeout(() => {
     elementToFocus.focus();
  }, 10);
} 

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(name) {
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length + 1, cookie.length);
      }
    }
    return "";
}
/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class HeaderContainer extends HTMLElement {
  constructor() {
    super();
    this.SearchButton = this.querySelector('#search-button');
    this.SearchModal = this.querySelector('#searchModal');
    this.DisplayHeader();
  }
  DisplayHeader(){
    const header = this.querySelector("header.header_container");
    if(window.location.pathname === this.dataset.root || window.location.pathname.includes(this.dataset.collections_url) ){
      
      if(header && header.id === 'header_transparent'){
         this.className = "absolute z-10 top-0 left-0 right-0 w-full"
      }
    }
  }

}
customElements.define('header-container', HeaderContainer);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    const is_autoplay = this.getAttribute('autoplay');
    const video_exist = this.getAttribute('data-media-id');
    const hide_cover = this.getAttribute('hide-cover');
    if(is_autoplay === "true" || (hide_cover === "true" && video_exist)) {
      return this.loadContent();
    };
    
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const is_autoplay = this.getAttribute('autoplay');
      const isLoop = this.getAttribute('loop');
      const vimeo_container = this.querySelector('#vimeo_container');
      const content = document.createElement('div');
      const videoId = this.getAttribute('data-media-id');
      const ele = this.querySelector('template').content.firstElementChild.cloneNode(true);
      let params = "";
      if(ele.classList.contains('js-youtube')){
        params = `?autoplay=${is_autoplay === "true" ? 1 : 0}&mute=1${isLoop === "true" ? `&playlist=${videoId}&loop=1` : ''}`
        ele.src += params;
      }
        if(ele.classList.contains('js-vimeo')){
          params = `?autoplay=${is_autoplay === "true" ? "1&muted=1" : "0"}${isLoop === "true" ? `&loop=1` : ''}`
        ele.src += params;
      } 
      content.appendChild(ele);

      this.setAttribute('loaded', true);
      let deferredElement;
      if (ele.classList.contains('js-vimeo') && vimeo_container) {
          vimeo_container.classList.remove('hidden')
          deferredElement = vimeo_container.appendChild(content.querySelector('video, model-viewer, iframe'));
        } else {
          deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe')); 
        }
      if (focus) deferredElement.focus();
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    
    this.firsttime = false;
    this.firstscroll = true;
    this.stickyHeader = document.querySelector(".sticky_header_anabled");
    this.section = document.querySelector(`[id^="GalleryStatus-${this.dataset.section}"]`);
    this.slider = this.section.querySelector('[id^="images-slider"]');
    this.slider_top = this.section.querySelector('[id^="images-slider"]') && this.section.querySelector('[id^="images-slider"]').getBoundingClientRect().top + window.pageYOffset;
    this.updateOptions();
    this.updateMasterId();
    this.updateMedia();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    
    this.options  = [...this.querySelectorAll('.select__dorpdown_color')].map(ele=>{
      
      if(ele.tagName === "SELECT"){
        return ele.value
      }
      else if(ele.tagName === "FIELDSET"){
        const data = Array.from(ele.querySelectorAll('input')).find((radio) => radio.checked);
        
        const img = data.getAttribute("data-url");
       
        if(data.value.includes(":#")){
          return data.value.split(":")[0];
        }else{
          return data.value;
        } 
      }
    })
    
  }

  updateMasterId() {
    
    this.currentVariant = this.getVariantData().find((variant) => {

      return !variant.options.map((option, index) => {
        return this.options[index] === option.split(':')[0] || this.options[index] === option;
      }).includes(false);
    });


    
    Array.from(this.querySelectorAll('[data-option]')).map(span =>{
          if(this.currentVariant){
              const selected = this.currentVariant[span.getAttribute('data-option')];
              span.classList.remove("visibility-hidden");
              if(selected && selected.includes(":#")){
                 span.textContent = selected.split(":")[0]; 
              }else{
                 span.textContent = selected;
              }
              
          }else{
              span.classList.add("visibility-hidden")
          }
    });
  
  }
  
  setInputAvailability(listOfOptions, listOfAvailableOptions) {

    listOfOptions.forEach(input => {
      if(input.type === "radio"){
          if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.classList.remove('disabled');
          } else {
                input.classList.add('disabled');
          }
      }else{
          if(listOfAvailableOptions.includes(input.getAttribute('value'))) {
                this.currentVariant.available && input.closest("select").classList.remove("line-through")
                input.innerText = input.getAttribute('value');
          } else {
            if(this.currentVariant.available){
              input.closest("select").classList.remove("line-through")
            }else{
              input.closest("select").classList.add("line-through")
            } 
          }
      }
  
    });
  }

  updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      
    
      const section = document.querySelector(`[id^="GalleryStatus-${this.dataset.section}"]`);
      if(!section) return
    
      const slider = section.querySelector('[id^="images-slider"]');
      
      if(!slider) return

      const desk_type = slider.getAttribute("data-desktop-type");

      let slider_data = slider.getBoundingClientRect();
    
      const variant = this.currentVariant.featured_media.preview_image.src;
        
      const variant_source = variant.replace(/(^\w+:|^)\/\//, '//')
    
      const ele = Array.from(slider.children).find((slide)=>{
        const slide_img = slide.querySelector("img");
        if(!slide_img) return;
        const source = slide_img.src.replace(/(^\w+:|^)\/\//, '//').split("?")[0];
        const img_variant = variant_source.split("?")[0];
        

        
        return source === img_variant;
      });
      
    
      if(ele){
        
          const targetImage = slider.querySelector(`[data-image="${ele.getAttribute('data-image')}"]`);
          const sliderLeft = slider.getBoundingClientRect().left;
          const sliderTop = slider.getBoundingClientRect().top;
          
          if(desk_type !== "slider" && window.innerWidth >= 850){
            
            if(this.firstscroll){
              scrollToElement(1000);
             this.firstscroll = false;
            }else{
              scrollToElement(10);
            }

            function scrollToElement(time){
                
                setTimeout(() => {
                  const targetRect = targetImage.getBoundingClientRect();
                  const slider_top = slider.getBoundingClientRect().top;
                  const scrollY = targetRect.top - window.innerHeight / 2 + targetRect.height / 2;

                  
                  if (targetImage) {
                    if(targetRect.top - slider_top  < 10){
                      window.scrollTo({
                      top: 0,
                      behavior: "smooth"
                    });
                    }else{
                      window.scrollBy({
                      top: scrollY,
                      behavior: "smooth"
                    });
                    }
                    
                  } 
                }, time);

              }
              
          }else{
            
            if(this.firsttime && slider.dataset.autoheight === "true") {
               
              slider.style.height = `${slider.offsetWidth * ele.dataset.height / ele.dataset.width }px`;
              this.firsttime = false;
            };
            

           if (targetImage) {
             const targetRect = targetImage.getBoundingClientRect();
             const scrollX = targetRect.left;
             
             slider.scrollBy({
                 left: scrollX - sliderLeft ,
                 behavior: "smooth"
              }) 
             
            }
            
          }
      } 
    
  }
  
  isElementVisible(element) {
        var rect = element.getBoundingClientRect();
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
      
        var isFullyVisible = rect.top >= 0 && rect.bottom <= windowHeight;
      
        return isFullyVisible;
  }


  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      const errorMessage = productForm.querySelector('#product_form-error');
      if(errorMessage && !errorMessage.classList.contains("hidden")) errorMessage.classList.add('hidden')
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
   /*  const section = this.closest('section');
    if (!section) return;
    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage(); */
  }

  renderProductInfo() {
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        const price = document.getElementById(`price-${this.dataset.section}`);
        const buttons = document.getElementById(`buy-buttons-${ this.dataset.section }`);
        const variant_picker = document.getElementById(`variant-picker-${ this.dataset.section }`);
        const options = variant_picker.querySelectorAll('.option_selected_value');
        const payButton = document.querySelectorAll('[data-shopify="payment-button"]')
        options.length > 0 && options.forEach(ele=> {
          if(this.currentVariant){
             const selected = this.currentVariant[ele.getAttribute('data-option')];
             if(selected && selected.includes(":#")){
                ele.textContent = selected.split(":")[0]; 
              }else{
                ele.textContent = selected;
              }
          }
        })
        
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant || !this.currentVariant.available, window.variantStrings.soldOut);
        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
        
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const buttonsContainer = productForm.querySelector(".shopiy-payment-buttons-container")
    const payButton = buttonsContainer.querySelector('[data-shopify="payment-button"]');
    const payButtons = payButton && payButton.querySelectorAll("button")
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      buttonsContainer.classList.add('hidden');
      payButton && payButton.classList.add('hidden');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      buttonsContainer.classList.remove('hidden');
      payButton && payButton.classList.remove('hidden');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      
      const data = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      
      if(data.value.includes(":#")){
        return data.value.split(":")[0];
      }else{
        return data.value;
      } 
      
    });
    
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

}
customElements.define('variant-radios', VariantRadios);

class ProductCard extends HTMLElement {
   constructor() {
    super();
    [...this.querySelectorAll("input")].map(input=>{
      input.addEventListener('change',()=> this.onVarChange(input));
    })
  }

  onVarChange(input) {
    
     const variant_container = this.querySelector('[data-variant-images]');
     if(variant_container.childElementCount === 0) return;
     const links = this.querySelectorAll('a');
     const data_variant = input.getAttribute("data-variant");
     const data_url = input.getAttribute("data-url");
     const link = input.getAttribute("data-vid");
     let selected;
     if(data_url && !data_url.includes("only-variant") && !data_url.includes("only--variant")){
       
        selected = [...variant_container.querySelectorAll('[variant-id]')].find(img => {
           const img_url  = img.getAttribute("data-url");
           return  img_url === data_url; 
       });
     }else{
       
       selected = [...variant_container.querySelectorAll('[variant-id]')].find(ele => ele.getAttribute('variant-img') === `${data_variant}`);
       
     }
    this.initialState(variant_container);
        if(selected){
          this.querySelector('.main_image').classList.add('hidden');
          variant_container.classList.remove('hidden');
          selected.classList.remove('hidden');
          this.updateLinks(links,link);
        }else{
         this.querySelector('.main_image').classList.remove('hidden');
         variant_container.classList.add('hidden');
        } 
     
  }
  updateLinks(links,id){ 
    [...links].map(link =>{
      let new_link = `${link.href.split("?")[0]}?variant=${id}`
     if(link.href){
       return link.href = new_link;
     }
    })
  }
  initialState(container){
    [...container.querySelectorAll('[variant-id]')].map(ele => !ele.classList.contains("hidden") && ele.classList.add("hidden"))
  }

}
customElements.define('product-card', ProductCard);

class ProductRating extends HTMLElement {
  constructor() {
    super();
    this.displayRating(this)
  }
  displayRating(){
    let rate = this.getAttribute('data-rating') * 1;

     const full_star = `
      <svg class="full_star" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M8.71468 0.878115C8.80449 0.601722 9.19551 0.601722 9.28532 0.878115L11.1778 6.70254C11.2179 6.82614 11.3331 6.90983 11.4631 6.90983H17.5873C17.8779 6.90983 17.9987 7.28171 17.7636 7.45254L12.809 11.0522C12.7039 11.1286 12.6599 11.264 12.7001 11.3876L14.5925 17.2121C14.6823 17.4884 14.366 17.7183 14.1309 17.5475L9.17634 13.9478C9.07119 13.8714 8.92881 13.8714 8.82366 13.9478L3.86912 17.5475C3.634 17.7183 3.31766 17.4884 3.40746 17.2121L5.29993 11.3876C5.3401 11.264 5.2961 11.1286 5.19095 11.0522L0.236404 7.45253C0.00129022 7.28171 0.122123 6.90983 0.41274 6.90983H6.5369C6.66687 6.90983 6.78205 6.82614 6.82221 6.70254L8.71468 0.878115Z" />
      </svg>
      `;
      const half_star = `
      <svg class="half_star" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M8.18237 7.57551L10 1.69353L11.8176 7.57551C11.9212 7.91072 12.2311 8.13932 12.582 8.13932H18.5219L13.6824 11.8363C13.416 12.0398 13.3047 12.3879 13.4037 12.7082L15.2408 18.653L10.4856 15.0204C10.1989 14.8014 9.80107 14.8014 9.51435 15.0204L4.75922 18.653L6.59627 12.7082C6.69525 12.3879 6.584 12.0398 6.31758 11.8363L1.47815 8.13932H7.41803C7.76887 8.13932 8.07878 7.91072 8.18237 7.57551Z" fill="transparent"/>
        <path d="M10 14.5V3L8 8H1.5L6.5 12L5.5 17.5L6.5 17L10 14.5Z" />
      </svg>
      `;
      const empty_star = `
        <svg class="empty_star" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M8.29774 6.85704L10 1.61803L11.7023 6.85704C11.8094 7.18666 12.1165 7.40983 12.4631 7.40983H17.9717L13.5152 10.6477C13.2348 10.8514 13.1174 11.2125 13.2245 11.5421L14.9268 16.7812L10.4702 13.5433C10.1898 13.3396 9.81016 13.3396 9.52977 13.5433L5.0732 16.7812L6.77546 11.5421C6.88256 11.2125 6.76523 10.8514 6.48484 10.6477L2.02828 7.40983H7.5369C7.88348 7.40983 8.19064 7.18666 8.29774 6.85704Z" fill="transparent"/>
        </svg>
      `;

      for(let i=0;i < 5;i++){
      if(rate > 0.7){
        this.innerHTML += full_star
      }
      else if(rate > 0.3 && rate <= 0.7 ){
        this.innerHTML += half_star
      }else{
        this.innerHTML += empty_star
      }
      rate = rate - 1;
      }
  }

}
customElements.define('product-rating', ProductRating);


document.addEventListener("DOMContentLoaded", function() {
  Baad.LazyLoadImage()
  //Baad.AnimateSection()
})
document.addEventListener("shopify:section:load",function(e) {
  Baad.LazyLoadImage()
  //Baad.AnimateSection()
})


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || event.relatedTarget.nodeName === 'MAIN' || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              
            }
          })
          .then(()=>{
            Baad.LazyLoadImage()
          })
          .catch(e => {
            console.error(e);
          });
      }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
